module.exports = __webpack_public_path__ + "assets/measure_recalls.5a47064c.svg";